"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceProfileAuthorizationPhraseResult = void 0;
var Contracts_1 = require("./Contracts");
var Exports_1 = require("./Exports");
/**
 * Output format
 * @class VoiceProfileAuthorizationPhraseResult
 */
var VoiceProfileAuthorizationPhraseResult = /** @class */ (function (_super) {
    __extends(VoiceProfileAuthorizationPhraseResult, _super);
    function VoiceProfileAuthorizationPhraseResult(reason, statusText, json) {
        var _this = _super.call(this, reason, statusText) || this;
        _this.privPhrases = [];
        Contracts_1.Contracts.throwIfNullOrUndefined(json, "phrases array");
        for (var _i = 0, json_1 = json; _i < json_1.length; _i++) {
            var item = json_1[_i];
            _this.privPhrases.push(item.passPhrase);
        }
        return _this;
    }
    Object.defineProperty(VoiceProfileAuthorizationPhraseResult.prototype, "phrases", {
        get: function () {
            return this.privPhrases;
        },
        enumerable: false,
        configurable: true
    });
    return VoiceProfileAuthorizationPhraseResult;
}(Exports_1.VoiceProfileResult));
exports.VoiceProfileAuthorizationPhraseResult = VoiceProfileAuthorizationPhraseResult;

//# sourceMappingURL=VoiceProfileAuthorizationPhraseResult.js.map
